import React, { useState, useEffect } from "react";
import styles from "./News.module.scss";
import SectionTitle from "../../../../components/SectionTitle/SectionTitle";
import NewsElement from "./Components/NewsElement/NewsElement";
import getRequest from "../../../../helpers/getRequest";
import { useTranslation } from "react-i18next";

const News = ({ currentLang }) => {
  const [news, setNews] = useState(null);
  const { t } = useTranslation();

  // Request for news
  useEffect(() => {
    try {
      getRequest("v1/news", null, currentLang.lang).then(async (response) => {
        const data = await response.data;
        console.log(data.news);
        setNews(data.news);
      });
    } catch (err) {
      console.log(err);
    }
  }, [currentLang]);

  return (
    <section className={styles.news}>
      <SectionTitle text={t("News")} />
      <div className={styles.news__wrapperUp}>
        <div className={styles.news__wrapper}>
          {news && news.length ? (
            <>
              {news.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).map((item) => {
                const {  title, descr, data, image_id, id } = item;
                return (
                  <NewsElement
                    title={title}
                    descr={descr}
                    data={data}
                    key={id}
                    image_id={image_id}
                  />
                );
              })}
            </>
          ) : (
            <div>{t("News is empty")}</div>
          )}
        </div>
      </div>
      <div className={styles.pseduo__track}></div>
    </section>
  );
};

export default News;
